import React, { useState, useRef, useEffect } from "react";
import "./configureAsset.css";
import { Button, Grid } from "@mui/material";
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import { convertToBase64 } from "src/util/utilFunctions";
import DeleteIcon from '@mui/icons-material/Delete';

const ImageForm = ({ configurationData, setApiBody }) => {
  const [image, setImage] = useState(null);
  const [sensorData, setSensorData] = useState([]);
  const [automaticMode, setAutomaticMode] = useState(false);
  const [imageUploaded, setImageUploaded] = useState(false);
  const [showClickHint, setShowClickHint] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const saveImageInState = (base64Image) => {
    setImage(base64Image);
  };

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result);
      setImageUploaded(true);
    };
    if (file) {
      reader.readAsDataURL(file);
      convertToBase64(file, saveImageInState);
    }
  };

  const handleAutomaticMode = () => {
    setAutomaticMode(!automaticMode);
    if (!automaticMode) {
      setShowClickHint(true);
    } else {
      setShowClickHint(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(sensorData);
  };

  const handleInputChange = (index, key, value) => {
    const updatedSensorData = [...sensorData];
    updatedSensorData[index][key] = parseInt(value);
    setSensorData(updatedSensorData);
  };

  const handleImageClick = (event) => {
    if (automaticMode) {
      const rect = event.target.getBoundingClientRect();
      const xpoint = ((event.clientX - rect.left) / rect.width) * 100;
      const ypoint = ((event.clientY - rect.top) / rect.height) * 100;
      setSensorData([...sensorData, { xpoint, ypoint }]);
    }
  };

  useEffect(() => {
    if (!automaticMode) {
      setShowClickHint(false);
    }
  }, [automaticMode]);

  useEffect(() => {
    if (image) {
      const visualizer = {
        assetId: configurationData.id,
        coordinates: sensorData,
        image: image.replace("data:image/png;base64,", ""),
      };
      console.log("api body in configure asset comp",visualizer)
      setApiBody(visualizer);
    }
  }, [sensorData, image]);

  const handleItemSelection = (event, index) => {
    const selectedItem = event.target.value;
    const updatedSensorData = [...sensorData];
    updatedSensorData[index].itemId = selectedItem;
    setSensorData(updatedSensorData);

    if (!selectedItems.includes(selectedItem)) {
      setSelectedItems([...selectedItems, selectedItem]);
    }
  };

  const handleDeleteRow = (index) => {
    const updatedSensorData = [...sensorData];
    updatedSensorData.splice(index, 1);
    setSensorData(updatedSensorData);
  };

  const availableItems = configurationData.items.filter(
    (item) => !selectedItems.includes(item.id)
  );

  return (
    <div className="image-form-container">
      <Grid container>
        <Grid md={6} sm={12} lg={6} xs={12}>
          <div className="wrapper">
            <form onSubmit={handleSubmit} className="labelForm">
              <Grid container>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <div className="imageInput">
                    <label htmlFor="image">Choose an Image:</label>
                    <input
                      type="file"
                      accept="image/*"
                      id="image"
                      onChange={handleImageUpload}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  {imageUploaded && (
                    <div className="buttonWrapper">
                      <ButtonPolicy onClick={handleAutomaticMode}>
                        {automaticMode ? "Disable Labeling" : "Enable Labeling"}
                      </ButtonPolicy>
                    </div>
                  )}
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {automaticMode && showClickHint && (
                    <p className="hint">
                      Hint: Click on the point on the image where you want to
                      add a label, and the x and y coordinates will be
                      automatically generated.
                    </p>
                  )}
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  {sensorData.map((sensor, index) => (
                    <div key={index} className="inputWrapper">
                      <div className="firstPart">
                        <label htmlFor={`x-${index}`}>X:</label>
                        <input
                          type="text"
                          id={`x-${index}`}
                          value={sensor.xpoint}
                          readOnly={!automaticMode}
                          onChange={(e) =>
                            handleInputChange(index, "xpoint", e.target.value)
                          }
                        />
                        <label htmlFor={`y-${index}`}>Y:</label>
                        <input
                          type="text"
                          id={`y-${index}`}
                          value={sensor.ypoint}
                          readOnly={!automaticMode}
                          onChange={(e) =>
                            handleInputChange(index, "ypoint", e.target.value)
                          }
                        />
                      </div>
                      <div className="secondPart">
                        <label htmlFor={`label-${index}`}>Item:</label>
                        <select
                          value={sensor.itemId}
                          onChange={(e) => handleItemSelection(e, index)}
                        >
                          <option value="">Select an item</option>
                          {availableItems.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.serialNumber}
                            </option>
                          ))}
                        </select>
                        <Button onClick={() => handleDeleteRow(index)}>
                          <DeleteIcon/>
                        </Button>
                      </div>
                    </div>
                  ))}
                </Grid>
              </Grid>
            </form>
          </div>
        </Grid>
        <Grid md={6} sm={12} xs={12} lg={6}>
          <div className="ImagePreviewWrapper">
            {!imageUploaded && (
              <div className="image-preview">
                <div>Image Preview</div>
              </div>
            )}

            {image && (
              <div
                className="image-preview"
                style={{ position: "relative" }}
                onClick={handleImageClick}
              >
                <img
                  src={image}
                  alt="Uploaded"
                  style={{ width: "100%", height: "100%" }}
                />
                {sensorData.map((sensor, index) => (
                  <div
                    key={index}
                    className="dot"
                    style={{
                      position: "absolute",
                      left: `${sensor.xpoint}%`,
                      top: `${sensor.ypoint}%`,
                    }}
                  >
                    <div className="labels">
                      {
                        configurationData.items.find(
                          (item) => item.id === sensor.itemId
                        )?.serialNumber
                      }
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default ImageForm;
